import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {LogoComponent} from './logo.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        LogoComponent
    ],
    exports: [
        LogoComponent
    ]
})
export class LogoModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/logo/logo.module.ts